import api from "./api";

const LeadershipService = {
    accountabilities: (employeeId) =>
        api.get(`/api/employees/${employeeId}/accountabilities/`),
    seats: (employeeId) => api.get(`/api/employees/${employeeId}/seats/`),
};

export default LeadershipService;
